import React, {useState, useEffect, useContext, useCallback, useMemo} from 'react';
import { AuthContext } from '../../../contexts/authContext';
import axios from 'axios';
import config from '../../../config';
import './Splashscreen.css';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import { useDropzone } from 'react-dropzone';
import Button from '@mui/material/Button';
import useNotification from '../../../hooks/useNotification';

const baseStyle = {
    //flex: 1,
    width: '230px',
    height: '90px',
    //marginLeft: '50px',
    display: 'flex',
    fontSize: '14px',
    flexDirection: 'column',
    alignItems: 'center',

    //padding: '50px',
    borderWidth: 3,
    borderRadius: 5,
    borderColor: '#aaaaaa',
    borderStyle: 'dashed',
    backgroundColor: '#fafafa',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
};

const focusedStyle = {
    borderColor: '#2196f3'
};

const acceptStyle = {
    borderColor: '#00e676'
};

const rejectStyle = {
    borderColor: '#ff1744'
};

function Splashscreen(props) {
    const auth = useContext(AuthContext);
    const {splashscreen, setSplashscreen} = useContext(AppAuthGlobalVariables)
    const { notificationSuccess, notificationError, notificationInfo } = useNotification();
    const [loading, setLoading] = useState(true);

    const [originalSplashscreen, setOriginalSplashscreen] = useState('');

    useEffect(() => {
        if(!splashscreen){
            getSplashscreen();
        }else{
            setLoading(false);
            setOriginalSplashscreen(splashscreen)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(!loading){
            getSplashscreen();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.city])

    const getSplashscreen = async() => {
        try {
            setLoading(true);

            const params = {
                idEntita: '1',
                city: props.city
            };

            const axiosParams = {
                url: '/get-splashscreen',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);
            
            setSplashscreen(response.data?.result?.Item?.photo?.S || '')
            setOriginalSplashscreen(response.data?.result?.Item?.photo?.S || '')
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logout();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    const modSplashscreen = async() => {
        try {

            setLoading(true);

            const essentialData = {
                idEntita: "1",
                city: props.city
            }

            if( splashscreen === originalSplashscreen){
                //se non ci sono chiavi non è cambiato nulla e ritorno
                return;
            }
            let form = new FormData();

            form.append('essentialData', JSON.stringify(essentialData));

            form.append('file', splashscreen);


            const axiosParams = {
                url: '/mod-splashscreen',
                method: 'post',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                data: form
            };

            const response = await axios(axiosParams);
            notificationSuccess('Splashscreen Aggiornato');
            let newOriginalItems = response.data.responseUpdate.Attributes
            setSplashscreen(newOriginalItems?.photo?.S || '');
            setOriginalSplashscreen(newOriginalItems?.photo?.S || '');
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logout();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setLoading(false);
        }
    }

    const onDrop = useCallback(async(acceptedFiles) => {
        //devo prendere il file e renderlo base64 per poi storarlo
        if(acceptedFiles.length===0){
            notificationInfo('Sono accette solo immagini in formato .jpg');
            return;
        }
        setSplashscreen(acceptedFiles[0])
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const {
        /* acceptedFiles, */
        getRootProps,
        getInputProps,
        /* open, */
        isFocused,
        isDragAccept,
        isDragReject
    } = useDropzone({onDrop, accept: {'image/jpeg':['.jpg'] },  multiple: false/* , maxFiles: 1, maxSize: 31457280 */});

    const dropZonestyle = useMemo(() => ({
        ...baseStyle,
        ...(isFocused ? focusedStyle : {}),
        ...(isDragAccept ? acceptStyle : {}),
        ...(isDragReject ? rejectStyle : {})
    }), [
        isFocused,
        isDragAccept,
        isDragReject
    ]);

    return (
        <div className='component-container splashscreen'>
            <div className='component-card'>
                <div className='box'>
                    <div className="dropBox" {...getRootProps({style: dropZonestyle})}>
                        <input {...getInputProps()} />
                        <p style={{textAlign: "center"}}>Clicca per caricare l'immagine</p>
                        <p style={{textAlign: "center"}}>Oppure trascina qui</p>
                    </div>
                    <Button disabled={originalSplashscreen === splashscreen} sx={{maxWidth: '200px'}} variant="contained" onClick={modSplashscreen}>Modifica Splashscreen</Button>
                    {!loading&&(<img alt='splashscreenImg' src={originalSplashscreen !== splashscreen ? URL.createObjectURL(splashscreen) : 'data:image/jpg;base64, '+originalSplashscreen}/>)}
                </div>
            </div>
        </div>
    )
}

export default Splashscreen